<template>
    <div class="question-wrapper">
      <transition :name="questionAnimation" mode="out-in">
        <question-helper v-if="playlistItemCount > 0 && currentItem" :duration="currentItem.duration" :key="currentItem.id">
          <div slot="question">
            <h2 v-html="currentItem.question"></h2>
          </div>
          <p slot="instruction" class="instruction" v-html="currentItem.instruction"></p>

          <fieldset v-if="currentItem.type == 'decision'" slot="fields">
            <textarea v-model="currentAnswer" class="rounded" placeholder="Write your answer here..." required></textarea>
          </fieldset>

          <fieldset v-if="currentItem.type == 'radio' || currentItem.type == 'checkbox'" slot="fields">
            <div 
              v-for="(option, index) in currentItem.options" 
              :key="option.id" 
              :class="currentItem.type" 
              :ref="'option-'+ option.id"
              class="option">
              <input 
                :type="currentItem.type"
                :id="'option-'+option.id"  
                :value="option.id" 
                v-model="currentAnswer">                
              <label 
                :for="'option-'+option.id">
                <span>{{String.fromCharCode(++index+64)}}</span>
                <div class="bordered rounded">{{option.label}}</div>
              </label>
            </div>
          </fieldset>

          <fieldset v-if="currentItem.type == 'rank'" slot="fields">
            <draggable
              class="list-group ranking-list"
              tag="ol"
              handle=".handle"
              v-model="currentItem.options"
              v-bind="dragOptions"
              @start="drag = true"
              @end="drag = false"
            >
              <li v-for="(option, index) in currentItem.options" :key="option.id" :id="option.id" :class="currentItem.type" class="option">
                <div class="index bordered rounded" :class="{filled: currentItem.max > index}">
                  {{index + 1}}
                </div>
                <label class="bordered rounded">{{option.label}}</label>
                <div class="handle">
                  <i class="material-icons">drag_handle</i>
                </div>
              </li>
            </draggable>
          </fieldset>

        </question-helper>
      </transition>
      <div class="question-navigation" v-if="playlistData && ! givingFeedback">
        <button 
          v-if="itemIndex !== 0"
          @click="itemIndex--"
          class="text">
          Previous decision
        </button>

        <button 
          @click="submitQuestion(currentItem.id)"
          class="btn submit rounded"
          :class="{answered: hasResponse(itemIndex)}">
            <transition name="slide-to-top" mode="out-in">
              <div class="index" :key="itemIndex">
                {{itemIndex + 1}}
              </div>
            </transition>
            <span>Submit</span>
            <i class="material-icons">arrow_forward</i>
        </button>

        <div class="remaining" v-text="remainingText"></div>
      </div>
      <div class="question-navigation" v-else-if="playlistData && givingFeedback">
        <button class="next-button btn rounded" @click="nextStep"><span>Next</span><i class="material-icons">arrow_forward</i></button>
      </div>
    </div>
</template>

<script>
import questionHelper from '@/components/trainee/QuestionHelper.vue';
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
import draggable from "vuedraggable";

export default {
  name: 'Decision',
  mixins: [scenarioMixin],
  components: {
    'question-helper': questionHelper,
    draggable
  },
  data() {
    return {
      questionAnimation: 'slide-to-left',
      currentAnswer: ["1"],
      responses: new Map(),
      itemIndex: null,
      givingFeedback: false
    }
  },
  mounted () {
    // set item index here
    // Hier zit een bug. Als je van tab wisselt zal je altijd bij 0 uitkomen
    // this.itemIndex = ( this.$route.query.d ? parseInt(this.$route.query.d) : 0)
    this.itemIndex = this.decisionIndex
    this.setCurrentAnswer(this.itemIndex)
    this.$emit('current', this.currentItem)
  },
  computed: {
    currentItem () {
      return this.playlistData.items[parseInt(this.itemIndex)]
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    remainingText () {
      if (this.playlistData.items.length - this.itemIndex == 1 ) {
        return 'Final decision'
      } else {
        return `${this.playlistData.items.length - this.itemIndex} decisions remaining`
      }
    },
    decisionIndex () {
      return this.$store.state.traineeStatusModule.decisionIndex
    }
  },
  methods: {
    submitQuestion (key) {
      if ( this.currentItem.type == 'rank') {
        this.currentAnswer = this.currentItem.options
      }
      // Turning this off for now. 
      // Might turn on again later.
      // if ( this.currentAnswer == "") {
      //   // alert('');
      //   const notification = {
      //     type: 'error',
      //     message: 'Please fill in the field'
      //   }
      //   this.$store.dispatch('notification/add', notification, { root: true })
      //   return;
      // }

      let obj = {
        [key]: {
          answer: this.currentAnswer,
          duration: 12,
          timestamp: Date.now()
        }
      }
      this.$store.dispatch('traineeStatusModule/mergeAnswer', obj)
      // this.responses.set(key, obj)

      // Check if we can give instant feedback
      if ( this.currentItem.correct ) {
        this.giveFeedback()
        
      } else {
        this.nextStep()
      }
      
    },
    giveFeedback () {
      this.givingFeedback = true

      this.currentItem.options.forEach(o => {
        let optionRef = 'option-'+o.id
        this.$refs[optionRef][0].getElementsByTagName('input')[0].disabled = true
        if ( this.currentItem.correct.includes(o.id) ) {
          // Correct answer
          this.$refs[optionRef][0].classList.add("correct")
        } else {
          // Wrong answer
          this.$refs[optionRef][0].classList.add("wrong")
        }
      })
    },
    nextStep () {
      this.givingFeedback = false
      // Not needed, but might be later.
      // this.$router.replace({'query': null});

      if ( this.itemIndex === ( this.playlistItemCount - 1) ) {
        let index = this.scenarioData.playlists.findIndex( (el) => el == this.playlistId)
        let nextPl = this.scenarioData.playlists[++index]

        if ( this.playlistData.outcomes && this.playlistData.outcomes.length > 0 ) {
          this.$emit("done", "outcomes")
        } else if ( nextPl ) {
          // const notification = {
          //   type: 'success',
          //   message: 'Playlist complete. Loading the next playlist.'
          // }
          // this.$store.dispatch('notification/add', notification, { root: true })
          this.$store.dispatch('traineeStatusModule/finishPlaylist')
          this.$router.push({ path: '/trainee/scenario/'+this.scenarioId+'/playlist/'+ nextPl })
        } else {

          const notification = {
            type: 'success',
            message: 'Scenario complete.'
          }
          this.$store.dispatch('notification/add', notification, { root: true })
          this.$emit("done", "done")
        }
        
      } else {
        // Next question
        this.itemIndex++
        this.currentAnswer = ""
        this.$store.dispatch('traineeStatusModule/setDecisionIndex', this.itemIndex)
      }
    },
    hasResponse (index) {
      // return this.responses.has( this.playlistData.items[index].id )
      if (! this.playlistData.items[index]) {
        return false
      }
      return this.$store.getters["traineeStatusModule/hasResponse"](this.playlistData.items[index].id);
    },
    setCurrentAnswer (val) {
      if ( this.hasResponse(val) ) {
        // this.currentAnswer = this.responses.get( this.playlistData.items[val].id ).answer
        this.currentAnswer = this.$store.getters["traineeStatusModule/getResponse"](this.playlistData.items[val].id);
        if ( this.currentItem.type == 'rank') {
          this.currentItem.options = this.currentAnswer
        }
      } else {
        this.currentAnswer = []
      }
    }
  },
  watch: {
    currentItem (val, oldVal) {
      this.$emit('current', this.currentItem)

      if ( oldVal && val.id > oldVal.id ) {
        this.questionAnimation = 'slide-to-left'
      } else {
        this.questionAnimation = 'slide-to-right'
      }
    },
    itemIndex (val) {
      this.$store.dispatch('traineeStatusModule/setDecisionIndex', val)
      this.setCurrentAnswer(val)
    },
  },
}
</script>

<style lang="scss" scoped>

.option.correct {
  label::before,
  .bordered {
    border-color: #21D64C !important;
  }
}
.option.wrong {
  label,
  .bordered {
    opacity: 0.6;
  }
  [type="checkbox"]:checked + label,
  [type="radio"]:checked + label {
    opacity: 1;

    &::before,
    .bordered {
      opacity: 1;
      border-color: red !important;
    }
  }
} 

.question-wrapper {
  overflow: hidden;
}
textarea {
  min-height: 160px;
  color: var(--primary);
  font-family: 'Roboto', sans-serif;
}
h2 {
  color: var(--primary);
  padding-right: 50px;

  @media all and (max-width: 767px) {
    font-size: 18px;
  }
}
.instruction {
  margin: 0 0 2em;
  color: var(--primary);
  font-size: 14px;
}
.question-navigation {
  margin-top: auto;
  padding: 20px 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;

  .remaining {
    flex: 0 0 100%;
    text-align: right;
    font-size: 12px;
    color: var(--primary);
    font-style: italic;
    margin-top: 1rem;
  }

  @media all and (max-width: 767px) {
    padding: 20px 15px;
  }
  
  ul {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  
  li {
    list-style: none;
    display: flex;
    margin-left: 10px;
  }

  .next-button {
    margin-left: auto;
  }

  .submit {
    margin-left: 2rem;
    padding-left: 1px;

    .index {
      background-color: #fff;
      border-radius: var(--border-radius);
      color: var(--primary);
      height: 34px;
      width: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1rem;
    }
  }

  // .number,
  // .submit {
  //   border: none;
  //   padding: 0;
  //   font-weight: bold;
  // }
  // .number {
  //   position: relative;
  //   width: 40px;
  //   // width: 100%;
  //   height: 40px;
  //   background-color: #b6f3d7;
  //   background-color: #E3E3E3;
  //   color: #3d3dde;
    
  //   z-index: 10;
  //   flex-shrink: 0;

  //   &.answered {
  //     background-color: #b6f3d7;
  //   }

  //   &:disabled {
  //     background-color: #E3E3E3;
  //   }
  // }
  // .submit {
  //   transition: all 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;
  //   background-color: #3d3dde;
  //   color: #fff;
  //   font-weight: bold;
  //   overflow: hidden;
  //   margin-left: -40px;
  //   padding-left: 40px;

  //   z-index: 5;
  //   flex-shrink: 0;
  //   text-indent: -200px;

  //   span {
  //     transition: all 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;
  //     white-space: nowrap;
  //     padding: 0;
  //   }

  //   &:hover {
  //     background-color: #cecece;
  //   }
  // }

  .active {
    .number {
      border: 2px solid #3d3dde;
    }
    .submit {
      text-indent: 0;

      span {
        padding: 0 13px;
      }
    }
  }
}



ol.ranking-list {
  list-style: none;
  padding: 0;

  li {
    display: flex;
    align-items: stretch;
    padding: 10px 0;
    .handle {
      display: flex;
      align-items: center;
      margin-right: 5px;
      cursor: move;
    }
    .index {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      line-height: 44px;
      background: #fff;
      color: #3d3dde;
      margin-right: 15px;

      &.filled {
        background: #3d3dde;
        color: #fff;
      }
    }
    label {
      flex: 1;
      color: #3d3dde;
      display: flex;
      align-items: center;
      padding: 7px;
    }
  }
}
  
</style>